import { useContext } from 'react'
import TypePicker, { ITypeOption } from 'Components/reusable/InputFields/TypePicker'
import { IWidget } from 'types/adminInterfaces'
import { IAllocation } from 'types/assignmentInterfaces'
import { TypeCode } from 'types/ids'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType } from '../types'

/**
 * Person picker.
 */
export const DataEditContextTypeField = <T extends AnyObject>({
  field,
  typeOptions,
  insetLabel,
  ...rest
}: {
  field: EditableFieldsOfType<T, TypeCode | null>
  typeOptions: ITypeOption[]
  insetLabel?: boolean
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, disabled, setFields, localeBase, t } = useContext<ContextValue<T>>(Context)

  const handleChange = (newValue: IAllocation | IWidget | null) => {
    setFields({ [field]: newValue })
  }

  const dataValue = flatData[field] as unknown as TypeCode

  return (
    <TypePicker
      onChange={handleChange}
      disabled={disabled[field] ?? false}
      value={dataValue}
      label={t(`${localeBase}.${field}`)}
      typeOptions={typeOptions}
      insetLabel={insetLabel}
      {...rest}
    />
  )
}

/**
 * Site picker.
 */
